import { Skeleton, Stack } from "@mui/material";

/**
 * Loading placeholder shaped like the analytics dashboard (filter bar, a stat
 * row, charts). Shown while the viewer session is fetched AND while the Luzmo
 * embed initializes, so the whole load reads as one continuous state instead
 * of a chain of unrelated spinners and loader messages.
 */
export function EmbeddedDashboardSkeleton() {
  // Height-adaptive: the chart blocks flex to fill whatever the host provides,
  // with minimums that add up to less than the LuzmoDashboard host's minHeight
  // so the overlay never spills past its container.
  return (
    <Stack direction="column" spacing={2} sx={{ height: "100%", p: 2 }}>
      <Skeleton
        variant="rounded"
        width="40%"
        height="2.25rem"
        sx={{ flexShrink: 0 }}
      />
      <Stack direction="row" spacing={2} sx={{ flexShrink: 0 }}>
        <Skeleton variant="rounded" height="5rem" sx={{ flex: 1 }} />
        <Skeleton variant="rounded" height="5rem" sx={{ flex: 1 }} />
        <Skeleton variant="rounded" height="5rem" sx={{ flex: 1 }} />
      </Stack>
      <Skeleton variant="rounded" sx={{ flex: 2, minHeight: "5rem" }} />
      <Stack direction="row" spacing={2} sx={{ flex: 1, minHeight: "4rem" }}>
        <Skeleton variant="rounded" height="100%" sx={{ flex: 2 }} />
        <Skeleton variant="rounded" height="100%" sx={{ flex: 1 }} />
      </Stack>
    </Stack>
  );
}
